import { render } from "./ProductCategoryDropdown.vue?vue&type=template&id=0fcac11d&scoped=true&ts=true"
import script from "./ProductCategoryDropdown.vue?vue&type=script&lang=ts"
export * from "./ProductCategoryDropdown.vue?vue&type=script&lang=ts"

import "./ProductCategoryDropdown.vue?vue&type=style&index=0&id=0fcac11d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcac11d"]])

export default __exports__